export default $axios => ({
  sync() {
    return $axios.get('v1/calendar/sync');
  },
  unSync() {
    return $axios.post('v1/calendar/un-sync');
  },
  get(start, end) {
    return $axios.get('v1/calendar/get-list-proposals-todos', {
      params: {
        start, end
      }
    })
  },
  callback(payload) {
    return $axios.get('/v1/calendar/sync/callback', {
      params: {
        code: payload.code || null,
      }
    });
  },
});
